import apiService from './api/api.service';

const mentorExpertiseService = {
  async createExpertise(data) {
    return apiService.post('/mentor-expertise', data);
  },

  async getMyExpertise() {
    return apiService.get('/mentor-expertise/my-expertise');
  },

  async getMentorExpertise(mentorId) {
    return apiService.get(`/mentor-expertise/mentor/${mentorId}`);
  },

  async getExpertiseByMentorId(mentorId) {
    return apiService.get(`/mentor-expertise/mentor/${mentorId}`);
  },

  async updateExpertise(id, data) {
    return apiService.put(`/mentor-expertise/${id}`, data);
  },

  async deleteExpertise(id) {
    return apiService.delete(`/mentor-expertise/${id}`);
  },

  async getIndustries() {
    return apiService.get('/mentor-expertise/industries');
  },

  async getJobProfilesByIndustry(industry) {
    return apiService.get(`/mentor-expertise/job-profiles/${encodeURIComponent(industry)}`);
  }
};

export default mentorExpertiseService;
